import {flattenDeep, sortBy, reverse} from "lodash";
import {
  fetchNativeTaskInfoByTaskIdApi,
  fetchNativeTaskBriefsByTaskIdApi,
  fetchNativeLogTypesApi,
  fetchNativeTaskDetailsByDetailIdsApi,
  fetchNativeSingleLogDetailByLogIdApi,
  fetchNativeDownloadUrlApi
} from "../../../common/api";
import {
  NATIVE_UPDATE_LOG_INFO,
  NATIVE_UPDATE_LOG_DOWNLOAD_URL,
  NATIVE_UPDATE_LOG_TYPES,
  NATIVE_UPDATE_BRIEFS,
  NATIVE_UPDATE_TASK_DETAIL,
  NATIVE_UPDATE_LOG_DETAIL,
  NATIVE_UPDATE_HIGH_LIGHT_INDEX,
  NATIVE_UPDATE_FOCUS_LOG_ID,
  NATIVE_UPDATE_LOGDETAIL_FILTER_CONDITIONS,
  NATIVE_UPDATE_LOG_TYPES_IN_TASK,
  NATIVE_UPDATE_SORTED,
  NATIVE_INITIAL_STATE
} from "./reducer";

import {getPageOfLogIdsBySingleLogId} from "../../../common/util";
import {convertBriefsToLoglistInfiniteScrollBriefs} from "../../../common/adapter";

function fetchNativeTaskDetailsIfNeeded(detailIds) {
  const normalizedDetailIds = Array.isArray(detailIds) ? detailIds.join(",") : detailIds;
  if (!normalizedDetailIds) {
    return Promise.resolve([]);
  }
  return fetchNativeTaskDetailsByDetailIdsApi(normalizedDetailIds);
}

function sortBriefsByTime(briefs, sorted) {
  const orderedBriefs = sortBy(briefs, item => Number(item.logTime));
  return sorted ? orderedBriefs : reverse(orderedBriefs);
}



export function fetchPageInitData(taskId, focusLogId) {
  return (dispatch, getState) => {
    return Promise.all([
      fetchNativeTaskInfoByTaskIdApi(taskId),
      fetchNativeLogTypesApi(),
      fetchNativeTaskBriefsByTaskIdApi(taskId)
    ])
      .then(([infoData, logTypeData, briefData]) => {
        // flatten the briefData
        briefData = flattenDeep(briefData);
        const { sorted } = getState().nativeLogDetail;
        briefData = sortBriefsByTime(briefData, sorted);
        let detailIds = [];
        if (briefData.length > 0) {
          if (focusLogId) {
            detailIds = getPageOfLogIdsBySingleLogId(briefData, focusLogId);
          } else {
            detailIds = getPageOfLogIdsBySingleLogId(briefData, briefData[0].id);
          }
        }
        return Promise.all([infoData, logTypeData, briefData, detailIds])
      })
      .then(([infoData, logTypeData, briefData,detailIds]) => {
        return Promise.all([infoData, logTypeData, briefData, fetchNativeTaskDetailsIfNeeded(detailIds)])
      })
      .then(([infoData, logTypeData, briefData, detailData]) => {
        const logTypeInTask = [...new Set(briefData.map(brief => brief.logType))];
        dispatch({
          type: NATIVE_UPDATE_LOG_INFO,
          logInfo: infoData
        });
        dispatch({
          type: NATIVE_UPDATE_LOG_TYPES,
          logTypes: logTypeData
        });
        dispatch({
          type: NATIVE_UPDATE_BRIEFS,
          briefs: briefData
        });
        // initialized filterConditions to make sure the logTypes all selected
        dispatch({
          type: NATIVE_UPDATE_LOGDETAIL_FILTER_CONDITIONS,
          filterConditions: {
            ...getState().nativeLogDetail.filterConditions,
            logTypes: logTypeInTask
          }
        });
        dispatch({
          type: NATIVE_UPDATE_LOG_TYPES_IN_TASK,
          logTypesInTask: logTypeInTask
        });
        dispatch({
          type: NATIVE_UPDATE_TASK_DETAIL,
          taskDetails: detailData
        });
      })
  };
}

export function updateFocusLogId(focusLogId) {
  return (dispatch, getState) => {


    if (focusLogId === -1) {
      dispatch({
        type: NATIVE_UPDATE_LOG_DETAIL,
        logDetail: null
      });
      dispatch({
        type: NATIVE_UPDATE_FOCUS_LOG_ID,
        focusLogId: focusLogId
      });
    } else {
      const state = getState();
      const { briefs, taskDetails } = state.nativeLogDetail;
      const detailIds = getPageOfLogIdsBySingleLogId(briefs, focusLogId);

      // 查找新的focusLogId是否已经从服务器加载，如果已加载，则忽略，如果未加载，则加载。
      if (taskDetails.find(item => item.id === focusLogId) === undefined) {
        return fetchNativeTaskDetailsIfNeeded(detailIds)
          .then(data => {
            dispatch({
              type: NATIVE_UPDATE_TASK_DETAIL,
              taskDetails: data
            });
          })
          .then(() => {
            return fetchNativeSingleLogDetailByLogIdApi(focusLogId);
          })
          .then(data => {
            dispatch({
              type: NATIVE_UPDATE_LOG_DETAIL,
              logDetail: data
            });
          }).then(() => {
            dispatch({
              type: NATIVE_UPDATE_FOCUS_LOG_ID,
              focusLogId: focusLogId
            });
          })
      } else {
        return fetchNativeSingleLogDetailByLogIdApi(focusLogId)
          .then(data => {
            dispatch({
              type: NATIVE_UPDATE_LOG_DETAIL,
              logDetail: data
            });
          })
          .then(() => {
            dispatch({
              type: NATIVE_UPDATE_FOCUS_LOG_ID,
              focusLogId: focusLogId
            });
          })
      }
    }
  };
}

export function updateFilterConditions(filterConditions) {
  return (dispatch, getState) => {
    dispatch({
      type: NATIVE_UPDATE_LOGDETAIL_FILTER_CONDITIONS,
      filterConditions: filterConditions
    });
    const { logInfo, sorted } = getState().nativeLogDetail;
    if (logInfo) {
        return fetchNativeTaskBriefsByTaskIdApi(logInfo.taskId, filterConditions.logTypes.join(","), filterConditions.keyword)
        .then(data => {
          const newBriefs  = sortBriefsByTime(flattenDeep(data), sorted);
          dispatch({
            type: NATIVE_UPDATE_BRIEFS,
            briefs: newBriefs
          });
          return newBriefs;
        })
        .then(newBriefs => {
          // 和进入页面/切换排序一致，只拉开头 3 页，剩余的由列表滚动时按需加载；
          // 之前是全部 id 一起请求，大任务几千条时 URL 超长、响应几十 MB 直接超时
          if (newBriefs.length === 0) {
            return [];
          }
          return fetchNativeTaskDetailsIfNeeded(getPageOfLogIdsBySingleLogId(newBriefs, newBriefs[0].id));
        })
        .then(data => {
          dispatch({
            type: NATIVE_UPDATE_TASK_DETAIL,
            taskDetails: data
          });
        });
    }
  };
}

export function updateHighLightIndex(start, end) {
  return (dispatch) => {
    dispatch({
      type: NATIVE_UPDATE_HIGH_LIGHT_INDEX,
      highlightStartIndex: start,
      highlightEndIndex: end
    });
  };
}

export function fetchDownloadUrl(taskId) {
  return (dispatch) => {
    return fetchNativeDownloadUrlApi(taskId)
      .then(data => {
        dispatch({
          type: NATIVE_UPDATE_LOG_DOWNLOAD_URL,
          logDownloadUrl: data
        });
      });
  };
}

export function fetchTaskDetail(detailIds, direction) {
  return (dispatch) => {
    return fetchNativeTaskDetailsIfNeeded(detailIds)
      .then(data => {
        dispatch({
          type: NATIVE_UPDATE_TASK_DETAIL,
          taskDetails: data,
          direction: direction
        });
      });
  };
}

export function initState() {
  return (dispatch) => {
    dispatch({
      type: NATIVE_INITIAL_STATE
    })
  }
}

export function updateSorted(sorted) {
  return (dispatch, getState) => {
    dispatch({
      type: NATIVE_UPDATE_SORTED,
      sorted: sorted
    });

    const { logInfo, filterConditions } = getState().nativeLogDetail;
    if (logInfo) {
      return fetchNativeTaskBriefsByTaskIdApi(logInfo.taskId, filterConditions.logTypes.join(","), filterConditions.keyword)
        .then(briefs => {
          const newBriefs = sortBriefsByTime(flattenDeep(briefs), sorted);
          if (newBriefs.length === 0) {
            return Promise.resolve([[], []]);
          }
          const detailIds = getPageOfLogIdsBySingleLogId(convertBriefsToLoglistInfiniteScrollBriefs(newBriefs, "native"), newBriefs[0].id);
          return Promise.all([detailIds, newBriefs]);
        }).then(([detailIds, sortedBriefs]) => {
          return Promise.all([sortedBriefs, fetchNativeTaskDetailsIfNeeded(detailIds)])
        }).then(([sortedBriefs, data]) => {
          dispatch({
            type: NATIVE_UPDATE_BRIEFS,
            briefs: sortedBriefs
          });
          dispatch({
            type: NATIVE_UPDATE_HIGH_LIGHT_INDEX,
            highlightStartIndex: -1,
            highlightEndIndex: -1
          });
          dispatch({
            type: NATIVE_UPDATE_FOCUS_LOG_ID,
            focusLogId: -1
          });
          dispatch({
            type: NATIVE_UPDATE_TASK_DETAIL,
            taskDetails: data
          });
        });
    }
  };
}


